import { User as SupabaseUser } from '@supabase/supabase-js';
export type User = SupabaseUser;

export const ROLES = {
  ADMIN: 'administrator',
  RECRUITER: 'recruiter',
  FREELANCER: 'freelancer',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

export type Permission =
  // Admin permissions
  | 'access_admin_dashboard'
  | 'manage_users'
  | 'generate_reports'
  | 'manage_content'

  // Recruiter permissions
  | 'post_jobs'
  | 'manage_jobs'
  | 'send_quote_requests'
  | 'manage_projects'
  | 'write_freelancer_reviews'

  // Freelancer permissions
  | 'manage_profile'
  | 'submit_quotes'
  | 'join_alliances'
  | 'write_recruiter_reviews';
